import {
  ClaimGetAllParams,
  ClaimGetAllResponse,
  ClaimGetResponse,
  ClaimUpdateRequest,
  ClaimUpdateResponse,
  SubmitClaimResponse,
} from '@quromedical/models';
import { trpc } from 'trpc';

export class ClaimApi {
  public async getAll(params: ClaimGetAllParams = {}): Promise<ClaimGetAllResponse> {
    return await trpc.client.claim.getAll.query({ ...params });
  }

  public async getOne(id: string): Promise<ClaimGetResponse> {
    return await trpc.client.claim.getById.query({ id });
  }

  public async update(body: ClaimUpdateRequest): Promise<ClaimUpdateResponse> {
    return await trpc.client.claim.update.mutate({
      ...body,
    });
  }

  public async submit(id: string): Promise<SubmitClaimResponse> {
    return await trpc.client.claim.submit.mutate({
      id,
    });
  }
}
